<style scoped>
.margin-l-r {
    margin: 0px 5px;
}
.des {
    margin: 10px;
}
</style>
<template>
  <div>
    <div class="line text-center">
      <Button
        class="margin-l-r"
        type="primary"
        icon="md-add"
        @click="addContract"
      >
        添加
      </Button>
      <Dropdown
        class="margin-l-r"
        trigger="click"
        placement="bottom"
        @on-click="downloadContract"
      >
        <Button type="warning">
          合同模板下载
          <Icon type="arrow-down-b" />
        </Button>
        <DropdownMenu slot="list">
          <!-- <DropdownItem name="/static/files/内容制作服务单20190621.docx">
            内容制作服务单20190621
          </DropdownItem>
          <DropdownItem name="/static/files/咨询服务单20190621.docx">
            咨询服务单20190621
          </DropdownItem>
          <DropdownItem name="/static/files/宣传推广服务单20190621.docx">
            宣传推广服务单20190621
          </DropdownItem>
          <DropdownItem name="/static/files/Service Sheet20190621.docx">
            Service Sheet20190621
          </DropdownItem>
          <DropdownItem name="/static/files/云账户_ 著作权登记材料.docx">
            云账户_ 著作权登记材料
          </DropdownItem>
          <DropdownItem name="/static/files/20221012143831_【新模板】薄荷阅读2022年宣传推广服务单模板_对私_20221009.docx">
            薄荷阅读2022年宣传推广服务单模板_对私
          </DropdownItem> -->
          <DropdownItem name="/static/files/20250918_[New Template]Service Sheet-成都终身.docx">
            Service Sheet-成都终身
          </DropdownItem>
          <DropdownItem name="/static/files/20260305【新模板】内容创作服务单(插画类、项目类适用)-自我实现.docx">
            内容创作服务单-自我实现
          </DropdownItem>
          <DropdownItem name="/static/files/20250918_【新模板】宣传推广服务单-成都终身.docx">
            宣传推广服务单-成都终身
          </DropdownItem>
          <DropdownItem name="/static/files/20250918_【新模板】宣传推广服务单-良师益友.docx">
            宣传推广服务单-良师益友
          </DropdownItem>
          <DropdownItem name="/static/files/20260305_【新模板】咨询服务单-成都终身.docx">
            咨询服务单-成都终身
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Select
        v-model="params.contract_status"
        style="width:100px"
        placeholder="所有"
        @on-change="doSearch()"
      >
        <Option
          v-for="item in type_list"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </Option>
      </Select>
      <Select
        v-model.number="params.flow_node_id"
        class="margin-l-r"
        placeholder="选择节点"
        style="width: 120px"
        @on-change="doSearch"
      >
        <Option :value="0">
          所有节点
        </Option>
        <Option
          v-for="(flow_node, index) in flow_nodes"
          :key="flow_node.id"
          :value="flow_node.id"
        >
          {{ flow_node.name }}
        </Option>
      </Select>
      <RadioGroup
        v-model="params.search_type"
        class="margin-l-r"
        type="button"
        @on-change="doSearch()"
      >
        <Radio label="pending">
          待我处理
        </Radio>
        <Radio label="related">
          与我相关
        </Radio>
        <Radio label="mine">
          我发起的
        </Radio>
        <Radio
          v-if="cur_customer.is_pl"
          label="team"
        >
          我的团队
        </Radio>
      </RadioGroup>
      <i-input
        v-model="params.search"
        class="margin-l-r"
        style="width: 150px"
        placeholder="输入关键字搜索"
        @on-enter="doSearch()"
      />
      <Ajaxbtn
        ref="searchBtn"
        class="margin-l-r"
        :url="query_url"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleContractData"
        @fail="handleContractFail"
        @finally="handleContractFinally"
      />
    </div>
    <div class="line text-center des">
      <a
        href="https://shimo.im/docs/xRvYd8jw8KXRGRpt/"
        target="_blank"
      >https://shimo.im/docs/xRvYd8jw8KXRGRpt/</a>
      <span class="color-error">《兼职外包流程详细指南》</span>
    </div>
    <div class="line">
      <Table
        v-if="!loading"
        size="small"
        :columns="columns"
        :max-height="table_height"
        :data="contracts"
        :loading="loading"
      />
    </div>
    <div class="line paginate-fix-bottom">
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <Editor
      ref="editor"
      @update="updateContract"
      @needTfModal="needTfModal"
    />
    <ContractDetailPendingModal
      ref="smodal"
      @success="doSearch"
    />
    <ClearModal
      ref="cmodal"
      @success="doSearch"
    />
    <UploadModal
      ref="uploadmodal"
      @success="doSearch"
    />
    <TfModal
      ref="tf_modal"
      contract-type="outsource"
    />
  </div>
</template>
<script route="/outsource/my_contract">
  import TfModal from '@/views/business/components/TfModal.jsx'
  import ContractDetailPendingModal from '@/views/business/components/ContractDetailPendingModal.jsx'
  import {F_BLOGGER_OUT_RECORDS} from '@/views/outsource/libs/constant.js'
  import BaseContract from './mixins/base_contract';
  import FlowUtil from '../../libs/flow_util';
  import { handleUserFlow } from '@/views/components/flow/utils.js'
  import Editor from './components/editor';
  import ClearModal from './components/ClearModal.jsx'
  import UploadModal from './components/UploadModal.jsx'
  import {ele_status_hash} from './fields'
  import UserFlowBase from '@/views/components/flow/user_flow_base';
  import OutsourceContract from '@/views/components/viewer/components/outsource_contract.vue'
  import {closeContractApi, outsourceContractRevokeApi, outsourceContractSignApi, outsourceContractSignRemindApi} from './services'
  const get_node_key_name = ['user_flow', 'current_user_flow_node', 'flow_node', 'key_name']
  export default {
    /* router_info_start */
    router_info: '/outsource/my_contract',
    /* router_info_end */

    components: { Editor, ContractDetailPendingModal, ClearModal, UploadModal, TfModal },
    mixins: [BaseContract],
    data() {
      return {
        query_url: this.$util.api.query_my_outsource_contract,
        params: {
          per_page: 10,
          page: 1,
          search: '',
          search_type: 'pending',
          contract_status: '',
          flow_node_id: 0
        },
        type_list: [
          {
            label: "所有",
            value: "",
          },
          {
            label: '正常',
            value: 'normal'
          },
          {
            label: '完结',
            value: 'closed'
          },
          {
            label: '废弃',
            value: 'deleted'
          }
        ],
        flow_nodes: [],
      }
    },
    computed: {
      is_legal() {
        // GROUP_LEGAL
        return this.cur_customer.groups && this.cur_customer.groups.includes('GROUP_LEGAL');
      },
      is_legal_outsourcing() {
        return this.cur_customer.groups && this.cur_customer.groups.includes('GROUP_LEGAL_OUTSOURCING');
      },
      hr_is_part_time_job() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash['hr_is_part_time_job']
      },
      table_height() {
        const window_height = this.$store.state.window_height;
        return window_height - 230;
      },
      columns() {
        this.teams_hash
        let columns = this.$util.clone(this.base_columns);
        columns = columns.map(column => {
          if (column.title === '详情') {
            return {
              type: 'expand',
              width: 50,
              render: (h, params) => {
                //         return h(ViewerItem, {
                //   props: {
                //     type: 'OutsourceContract',
                //     model_id: row.id,
                //     tip: false
                //   },
                //   'class': {
                //     link: true
                //   }
                // }, '查看')
                return h(OutsourceContract, {
                  props: {
                    model_id: params.row.id,
                    showAdd: true
                  },
                  on:{
                    addTf:(val, call) => {
                      this.$refs.tf_modal.edit(val, {
                        closeCall:call
                      })
                    }
                  }
                })
              }
            }
          }
          if (column.title === '编号') {
            return {
              title: '编号',
              align: 'center',
              minWidth: 100,
              render: (h, params) => {
                const row = params.row;
                const user_flow = row.user_flow
                const electronic_contract = row.electronic_contract
                const ret = [
                  h('div', row.uid),
                ]
                if (row.closed) {
                  ret.push(h('div', {
                    style: {
                      color: '#19be6b',
                      'text-align': 'center'
                    }
                  }, '[已完结]'))
                }
                if (electronic_contract) {
                  let color = '#19be6b'
                  switch (electronic_contract.status) {
                  case 5:
                    color = '#ff9900'
                    break;
                  case 6:
                    color = '#ed4014'
                    break;
                  default:
                   
                    break;
                  }
                  ret.push(h('span', {
                    style: {
                      color,
                      'text-align': 'center'
                    }
                  }, [
                    `[电子合同状态：${ele_status_hash[electronic_contract.status]}]`
                  ]))
                }
                if (this.params.search_type === 'pending') {
                  if (row.del) {
                    ret.push(h('div', {
                      'class': {
                        'color-error': true
                      }
                    }, '[已废弃]'));
                  }
             
                  if (!row.has_payment) {
                    ret.push(h('div', {
                      'class': {
                        'color-warning': true
                      }
                    }, '暂无付款记录'));
                  }
                  const arr = handleUserFlow({user_flow, current_user_id:this.cur_customer.id, need_handle:true})
                  if (arr && arr.length) {
                    ret.push(h('div', {}, arr.map(item => {
                      return h('Tag', {
                        color: item.color,
                        type: 'border',
                        fade: false,
                      }, [item.text])
                    })))
                  }
                }
                if (row.is_auto) {
                  ret.push(h('div', {
                    style: {
                      color: '#19be6b',
                      'text-align': 'center'
                    }
                  }, '[自动生成]'));
                }
                return h('div', {
                  'class': {
                    'text-center': true
                  }
                }, ret);
              }
            }
          }
          if (column.title === '状态') {
            return {
              title: '状态',
              minWidth: 125,
              align: 'center',
              render: (h, params) => {
                const row = params.row;
                const user_flow = row.user_flow;
                if (user_flow) {
                  return h(UserFlowBase, {
                    props: {
                      user_flow: user_flow,
                      model: row,
                      title: row.name,
                      submitOutValid: () => {
                        if (!row.is_electronic) {
                          return true
                        }
                        const node_key_name = get_node_key_name.reduce((total, key) => {
                          total = (total || {})[key]
                          return total
                        }, row) 
                        // const need_clear = row.need_clear
                        const final_contract_file = (row.electronic_contract || {}).final_contract_file
                        // 到了法务财务节点，且合同未被清理操作过，且是法务组
                        // 20230117_不再使用此步骤
                        // if (node_key_name === 'law_fin_audit' && 
                        //   ![true, false].includes(need_clear) &&
                        //   this.is_legal) {
                        //   this.clearContract(row)
                        //   return false
                        // }
                        if (node_key_name === 'contract_clear' && !final_contract_file) {
                          this.uploadFinallyContract(row)
                          return false
                        }
                        if (node_key_name === 'proposer_sign') {
                          this.$vModal.warning({
                            title: '提示',
                            content: '需要去【操作】中进行签约/撤销'
                          })
                          return false
                        }
                        return true
                      }
                    },
                    'class': {
                      'text-left': true
                    }
                  })
                } else {
                  return h('div', '-');
                }
              }
            }
          }
          return column
        })
        columns.push({
          title: '操作',
          align: 'center',
          width: 75,
          fixed: 'right',
          render: (h, params) => {
            const cur_customer = this.cur_customer
            const row = params.row;
            let items = [];
            const can_q_c = [row.apply_user_id] 
            const can_q_c_t_x = [row.apply_user_id, row.fill_user_id] 
            const is_bohe = row.team_id === 277
            if (!row.closed) {
              items.push(h('DropdownItem', {
                props:{name: 'fk'}
              }, '申请付款'));
            }
            // 有 是否兼职的按钮权限 也可编辑
            if (FlowUtil.canEdit(row, this.cur_customer) || this.hr_is_part_time_job) {
              items.push(h('DropdownItem', {
                props:{name: 'edit'}
              }, '编辑'));
       
              items.push(h('DropdownItem', {
                props:{name: 'delete', divided: true}
              }, '废弃'));
            }
            if (this.is_legal) {
              items.push(h('DropdownItem', {
                props:{name: 'clear', divided: true}
              }, '合同清理'))
            }
            if (this.is_legal_outsourcing) {
              items = items.concat([
                h('DropdownItem', {
                  props:{name: 'upload_finally', divided: true}
                }, '上传终版合同'),
              ])
            }
          
            if (is_bohe) {
              can_q_c.push(row.fill_user_id)
            }
            // getsafe
            if (can_q_c.includes(cur_customer.id)) {
              items = items.concat([
                h('DropdownItem', {
                  props:{name: 'revocation', divided: true}
                }, '撤销电子合同'),
                h('DropdownItem', {
                  props:{name: 'sign_contract', divided: true}
                }, '签约电子合同'),
              ])
            }
            if (can_q_c_t_x.includes(cur_customer.id)) {
              items = items.concat([
                h('DropdownItem', {
                  props:{name: 'sign_contract_remind', divided: true}
                }, '签约提醒')
              ])
            }
            // sign_contract
            items.push(h('DropdownItem', {
              props:{name: 'finish', divided: true}
            }, '完结'));
            // items.push(h('DropdownItem', {
            //   props:{name: 'is_not_close', divided: true}
            // }, '未完结'))
            if (!items.length) {
              return h('div', '-');
            }
            return h('Dropdown', {
              props: {
                trigger: 'click',
                placement: 'left'
              },
              on: {
                'on-click': (event_name) => {
                  this.handleContractEvent(event_name, row, params.index);
                }
              }
            }, [
              h('div', {
                class: {
                  link: true
                }
              }, [
                h('span', '操作'),
                h('Icon', {
                  props: {
                    type: 'ios-arrow-down'
                  }
                })
              ]),
              h('DropdownMenu', {
                slot: 'list'
              }, items)
            ]);
          }
        });
        return columns;
      }
    },
    created() {
      this.cur_customer // 建立索引
      this.teams_hash
      this.getFlowInfo()
      //
    },
    mounted() {
      this.init() 
      this.doSearch();
    },
    methods: {
      getFlowInfo() {
        FlowUtil.getFlowInfo('OutsourceContract').then((flow_info) => {
          this.flow_nodes = flow_info.nodes;
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: `<p>获取流程信息失败, 请重试</p><p>${e.message}</p>`});
        });
      },
      needTfModal(params) {
   
        this.$refs.tf_modal.edit(params)
      },
      createRecords() {
        const params = localStorage.getItem(F_BLOGGER_OUT_RECORDS)
        if (!params) {
          return 
        }
        this.$refs.editor.createRecords(JSON.parse(params))
        localStorage.removeItem(F_BLOGGER_OUT_RECORDS)
      },
      init() {
        this.createRecords()
      },
      deleteContractProxy(contract) {
        const status = contract.electronic_contract && contract.electronic_contract.status
        if (contract.is_electronic && status !== 1) {
          this.$vModal.warning({
            title: '提示',
            content:'电子合同只有在未开启时才能被废弃！'
          })
          return 
        }
        this.deleteContractV1(contract);
      },
      notClose(data) {
        this.$refs.smodal.edit({...data, type:3})
      },
      finish(contract) {
        this.$vModal.confirm({
          title:'提示',
          content: '请确定是否将该合同做完结处理！',
          loading:true,
          onOk:({
            destroy,
            stopLoading
          }) => {
            closeContractApi({id: contract.id, is_finish: true}).then(() => {
              this.$Message.success({
                content: '操作成功!'
              });
              this.$refs.searchBtn.doAjax()
            }).finally(() => {
              destroy()
            })
          }
                      
        })
      },
      fk(contract) {
        let tx = ''
        // if (contract.contract_nature === 'frame') {
        //   tx = '不可对框架协议类合同直接付款，请在其关联的子合同上付款！' 
        // }
        if (contract.del) {
          tx = '已作废的合同不可付款'
        }
        // if (contract.status !== 'stamped' && !tx) {
        //   tx = '请完成法务盖章后，合同才可付款！'
        // }
        if (tx) {
          this.$vModal.error({
            title: '提示',
            content: tx
          })
          return 
        }
        localStorage.setItem('contract_id_outsource', JSON.stringify(contract));
        window.open('/mine/expense_group_company', '_blank');
      },
      handleElectContract({contract, keys = get_node_key_name, str_tip, str_tip_e = '只有电子合同才可以进行此操作！', target_key}) {
        const is_correct_node = keys.reduce((total, key) => {
          total = (total || {})[key]
          return total
        }, contract) !== target_key
        let str = ''
        if (!contract.is_electronic) {
          str = str_tip_e
        }
        if (is_correct_node && !str) {
          str = str_tip
        }
        if (str) {
          this.$vModal.warning({
            title: '提示',
            content: str
          })
          return false
        }
        return true
      },
      electronic_contract_status(contract, status, content) {
        if (!status.includes(contract.electronic_contract.status)) {
          this.$vModal.warning({
            title:'提示',
            content
          })
          return true
        }
        return false
      },
      // 撤销电子合同
      handleRevocation(contract) {
      
        if (!this.handleElectContract({
          contract,
          target_key: 'proposer_sign',
          str_tip:'只有在【申请人签约】节点才能撤销合同！',
          str_tip_e: '只有电子合同才可以进行此操作'
        })) {
          return 
        }
        // if (this.electronic_contract_status(contract, [2, 3], '【只有已发送通知】与【对方以签约】的电子合同可以撤销')) {
        //   return 
        // }

        this.$vModal.confirm({
          title:'提示',
          content: '确定撤销该合同？',
          loading:true,
          onOk:({
            destroy,
            stopLoading
          }) => {
            outsourceContractRevokeApi({id: contract.id}).then(() => {
              this.$Message.success({
                content: '撤销成功!'
              });
              setTimeout(() => {
                this.$refs.searchBtn.doAjax()
              }, 500)
            }).then(() => {
              destroy()
            }).finally(() => {
              stopLoading()
            })
          }
        })
      },
      // 签约电子合同
      handleSign(contract) {
        if (!this.handleElectContract({
          contract,
          target_key: 'proposer_sign',
          str_tip:'只有在【申请人签约】节点才能签约合同！',
          str_tip_e: '只有电子合同才可以进行此操作'
        })) {
          return 
        }
        if (this.electronic_contract_status(contract, [3], '【对方已签约】的电子合同可以签约')) {
          return 
        }
        this.$vModal.confirm({
          title:'提示',
          content: '确定签约该合同？',
          loading:true,
          onOk:({
            destroy,
            stopLoading
          }) => {
            outsourceContractSignApi({id: contract.id}).then(() => {
              this.$Message.success({
                content: '签约成功!'
              });
              setTimeout(() => {
                this.$refs.searchBtn.doAjax()
              }, 500)
            }).then(() => {
              destroy()
            }).finally(() => {
              stopLoading()
            })
          }
        })
        
        // outsourceContractSignApi
      },
      signContractRemind(contract) {
        if (!this.handleElectContract({
          contract,
          target_key: 'proposer_sign',
          str_tip:'只有在【申请人签约】节点才能发送提醒！',
          str_tip_e: '只有电子合同才可以进行此操作'
        })) {
          return 
        }
        this.$vModal.confirm({
          title:'提示',
          content: `【${contract.uid}】确定要给对方发送签约提醒？`,
          loading:true,
          onOk:({
            destroy,
            stopLoading
          }) => {
            outsourceContractSignRemindApi({id: contract.id}).then(() => {
              this.$Message.success({
                content: '提醒成功!'
              });
       
            }).then(() => {
            
            }).finally(() => {
              stopLoading()
              destroy()
            })
          }
        })
      },
      // 清理电子合同
      clearContract(contract) {
        if (!this.handleElectContract({
          contract,
          target_key: 'law_fin_audit',
          str_tip:'只有【法务财务审核】节点才能清理电子合同！',
          str_tip_e: '只有电子合同才可以进行此操作'
        })) {
          return 
        }
        this.$refs.cmodal.edit(contract)
      },
      uploadFinallyContract(contract) {
        if (!this.handleElectContract({
          contract,
          target_key: 'contract_clear',
          str_tip:'只有【合同清理】节点才能上传合同！',
          str_tip_e: '只有电子合同才可以进行此操作！'
        })) {
          return 
        }
        this.$refs.uploadmodal.edit(contract)
      },
      handleContractEvent(event_name, contract, index) {
        switch (event_name) {
        case 'edit':
          this.editContract(contract);
          break;
        case 'fk':
          this.fk(contract)
          break
        case 'payment':
          //this.editContractExpenseGroup(contract);
          break;
        case 'store-file':
          //this.storeContractFile(contract);
          break;
        case 'delete':
        
          this.deleteContractProxy(contract)
          break;
        case 'finish':
          this.finish(contract)
          break;
        case 'is_not_close':
          this.notClose(contract);
          break;
        case 'clear': 
          this.clearContract(contract)
          break;
        case 'upload_finally':
          this.uploadFinallyContract(contract)
          break
        case 'revocation':
          this.handleRevocation(contract)
          break
        case 'sign_contract':
          this.handleSign(contract)
          break
        case 'sign_contract_remind':
          this.signContractRemind(contract)
          break
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      downloadContract(contract_path) {
        window.open(contract_path, '_blank');
      }
    }
  }
</script>
